// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.legend-container{
    background: #fff;
    padding: 10px 20px;
}

.legend-container h3{
    margin: 0;
}

.legend-list{
    margin: 0;
    padding: 0;
    list-style-type: none;
}
.legend-list li {
    display: flex;
    margin: 8px 0;
}
.legend-list .color{
    width: 20px;
    height: 20px;
    margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/controls/map/legend/legend.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":["\r\n.legend-container{\r\n    background: #fff;\r\n    padding: 10px 20px;\r\n}\r\n\r\n.legend-container h3{\r\n    margin: 0;\r\n}\r\n\r\n.legend-list{\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style-type: none;\r\n}\r\n.legend-list li {\r\n    display: flex;\r\n    margin: 8px 0;\r\n}\r\n.legend-list .color{\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-right: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
